export default __webpack_public_path__ + "static/media/Wraps of the Earth Mother.f1b2e61f.jpg";